const baseJson = () => {
    return {
        id: null,
        groupCongViecId: null,
        content: null,
        nguoiThucHien: null,
        phoiHop: null,
        listPhoiHop: null,
        tuNgayDate: null,
        tuNgayTime: null,
        denNgayDate: null,
        denNgayTime: null,
        ngayKetThuc: null,
        thongTinThem: null,
        trangThai: null,
        percentTienDo: 0,
        ghiChu: null,
        createdAt: null,
        modifiedAt: null,
        createdBy: null,
        modifiedBy: null,
    }
}

export const tienDoCongViecModel = {
    baseJson
}
